<template>
  <div class="exhibition-list">
    <div class="exhibition-list__search">
      <el-input
        v-model="keyword"
        placeholder="请输入关键词"
        clearable
        @keyup.enter.native="handleSearch"
      />
      <button type="button" class="exhibition-list__search-btn" @click="handleSearch">
        搜索
      </button>
    </div>

    <p class="exhibition-list__total">共检索到 <em>{{ total }}</em> 条报告</p>

    <article
      v-for="item in list"
      :key="item.id"
      class="exhibition-card"
    >
      <div class="exhibition-card__thumb">
        <img :src="item.image" :alt="item.title" />
      </div>
      <div class="exhibition-card__body">
        <h3 class="exhibition-card__title">{{ item.title }}</h3>
        <p class="exhibition-card__desc">{{ item.description }}</p>
        <router-link :to="`/exhibition/${item.id}`" class="exhibition-card__link">
          查看专题 &gt;
        </router-link>
      </div>
    </article>

    <div v-if="!list.length" class="exhibition-list__empty">
      暂无相关主题展览
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExhibitionList',
  props: {
    list: { type: Array, default: () => [] },
    total: { type: Number, default: 0 }
  },
  data() {
    return {
      keyword: ''
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.keyword.trim())
    },
    setKeyword(keyword) {
      this.keyword = keyword || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.exhibition-list {
  &__search {
    display: flex;
    gap: $spacing-sm;
    margin-bottom: $spacing-md;
  }

  &__search-btn {
    flex-shrink: 0;
    padding: 0 $spacing-xl;
    height: 36px;
    background: $color-brown-dark;
    color: $color-white;
    font-size: rem(14);
    border-radius: 4px;
    transition: background 0.2s;

    &:hover {
      background: $success-color;
    }
  }

  &__total {
    font-size: rem(13);
    color: $color-text-light;
    margin-bottom: $spacing-base;

    em {
      font-style: normal;
      font-weight: 600;
      color: $color-brown-dark;
    }
  }

  &__empty {
    padding: $spacing-3xl;
    text-align: center;
    color: $color-text-light;
    background: $color-white;
    border-radius: 4px;
  }
}

.exhibition-card {
  display: flex;
  gap: $spacing-base;
  padding: $spacing-base;
  background: $color-white;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba($color-brown-dark, 0.06);
  margin-bottom: $spacing-base;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 20px rgba($color-brown-dark, 0.1);
  }

  &__thumb {
    width: 200px;
    height: 130px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: grayscale(0.4) sepia(0.15);
    }
  }

  &__body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-family: $font-serif;
    font-size: rem(18);
    font-weight: 700;
    color: $color-brown-dark;
    margin-bottom: $spacing-sm;
  }

  &__desc {
    flex: 1;
    font-size: rem(13);
    line-height: 1.8;
    color: $color-text-light;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__link {
    align-self: flex-end;
    margin-top: $spacing-sm;
    font-size: rem(13);
    color: $success-color;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .exhibition-card {
    flex-direction: column;

    &__thumb {
      width: 100%;
      height: 160px;
    }
  }
}
</style>
